import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'property-types-module';

export function pushHandlerClickData(propertyType, index) {
    const fastPathEventOptions = {
        action_location: ACTION_LOCATION,
        event_refinement: `${propertyType},position:${index}`,
    };

    return () => {
        pushEdapEvent('content_tile.selected', fastPathEventOptions);
    };
}

export const pushHandleNextData = () => {
    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'next arrow clicked',
    });
};

export const pushHandlePrevData = () => {
    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'previous arrow clicked',
    });
};
